module.exports = __webpack_public_path__ + "img/newchris-54.156e3b4a.jpg";